import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import ErrorBoundary from './components/ErrorBoundary'
import { ThemeProvider } from './contexts/ThemeContext'
import { AuthProvider } from './contexts/AuthContext'
import { installFetchAuth } from './lib/api'
import './i18n'
import './index.css'

// Instalado antes do primeiro render: daí em diante todo fetch para /api leva o header
// anti-CSRF nos métodos que gravam e um 401 derruba a sessão num lugar só.
installFetchAuth()

// A página de impressão do relatório roda num Chromium sem sessão e se autentica com o
// token de escopo fechado. Montar o AuthProvider ali dispararia um /api/auth/me que só
// pode dar 401, gravado na auditoria como recusa — uma negação falsa por PDF gerado,
// poluindo justamente a trilha onde se procura ataque real.
const isReport = new URLSearchParams(window.location.search).get('report') === '1'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary>
      <ThemeProvider>
        {isReport ? <App /> : <AuthProvider><App /></AuthProvider>}
      </ThemeProvider>
    </ErrorBoundary>
  </React.StrictMode>
)
